// extracted by mini-css-extract-plugin
module.exports = {"container":"TraitCard_container__2fkke","label":"TraitCard_label__zqJcv","trait":"TraitCard_trait__2h6IK","percentage":"TraitCard_percentage__3yG5i"};